import React from "react";
import "../style/components/ReservationSession.css";
import { PHONE_NUMBER } from "../utils/utils";

function ReservationSession({ reservation }) {
  const { backgroundImage, heading, label } = reservation;
  return (
    <div className="reservation-session">
      <img
        className="background-image"
        style={{ filter: "brightness(75%)" }}
        src={backgroundImage ?? ""}
        alt="reservation-background"
      />
      <div className="reservation-container">
        <h1 style={{ color: "white" }}>{heading}</h1>
        <a
          href={`tel:${PHONE_NUMBER}`}
          className="custom-button-link"
          style={{ color: "white" }}
        >
          {label} {PHONE_NUMBER}
        </a>
      </div>
    </div>
  );
}

export default ReservationSession;
